export default __webpack_public_path__ + "static/media/logo.6276dcc4.svg";